export default "__VITE_ASSET__C7_8C$v0__"